<template>
  <div class="login-safe-check" >
    <template v-if="!isChecked">
      <em class="login-safe-spinning iconfont icon-refresh_icon"></em>
      <span class="login-safe-text">
        {{ letter.safeChecking }}
      </span>
    </template>
    <template v-else>
      <em class="login-safe-success iconfont icon-safe_icon"></em>
      <span class="login-safe-text">
        {{ letter.safeChecked }}
      </span>
    </template>
  </div>
</template>

<script>
import login from '@mixins/officialWebStore/login';
import { mapState, mapGetters } from 'vuex';

export default {
  mixins: [login],
  data() {
    return {
      isChecked: false
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter
    }),
    ...mapGetters(['gameInfoConfig'])
  },
  mounted() {
    // 定时随机2-5秒后显示安全检测成功
    setTimeout(() => {
      this.isChecked = true;
    }, Math.random() * 3000 + 2000);
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';

.login-safe-check {
  width: 100%;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 19px 0;
  margin-top: 21px;
  text-align: center;

  .login-safe-spinning {
    display: inline-block;
    font-size: 26px;
    color: #bcbcbc;
    animation: rotate 1s linear infinite;
    animation-direction: reverse;
  }
  .login-safe-success {
    font-size: 26px;
  }
  .login-safe-text {
    font-size: 22px;
    color: #333333;
  }
}

@media screen and (orientation: landscape) {
  .login-safe-check {
    width: 100%;
    padding: 11px 0;
    margin-top: 21px;
    border-radius: 3px;

    .login-safe-spinning {
      font-size: 19px;
    }
    .login-safe-success {
      font-size: 19px;
    }
    .login-safe-text {
      font-size: 16px;
    }
  }
}
</style>
